import { Injectable } from '@angular/core';
import { EngineService } from './engine.service';
import { PlayConfigurationModel } from './models/animation/play-configuration.model';
import { TimerangeModel } from './models/animation/timerange.model';
import { plainToClass } from 'class-transformer';
import { ChapterModel } from '../story/models/chapter.model';

import * as _ from 'lodash';

declare const Human: any;

@Injectable({
  providedIn: 'root'
})
export class AnimationService {

  constructor(
    private engineService: EngineService
  ) { }

  getChapterLocalTimerange(chapterId: string): TimerangeModel {
    const chapter = Human.timeline.activeRoot._chapters.find(_chapter => _chapter.id === chapterId);
    return plainToClass(TimerangeModel, chapter.timeRange as object);

    // Human.timeline.activeRoot._nowBranch;
    // get branch timeline:               <branch>.getTimeframe()
    // convert local to globalTime:       Human.timeline.activeRoot.mapBranchTime(<branch>, 1);
    // scrub animation using globalTime:  Human.timeline.scrub(globalTime):  
  }

  mapGlobalTimeToLocal(time: number): number {
    return Human.timeline.activeRoot.mapGlobalTime(time).time;
  }

  mapLocalTimeToGlobal(chapterId: string, time: number): number {
    const branch = Human.timeline.activeRoot._chapters.find(chapter => chapter.id === chapterId);
    return Human.timeline.activeRoot.mapBranchTime(branch, time);
  }

  isChapterAnimated(chapter) {
    const isAnimated = chapter.timelineMap
      .filter(timeline => {
        return _.get(timeline, 'data.timeline') !== 'dummy' &&
          _.get(timeline, 'data.timeline.id') !== 'dummy';
      }).length > 0;

    return isAnimated;  
  }

  scrub(time, which: 'first' | 'second' = 'first') {
    Human.timeline.scrub({
      time: time,
      borderCondition: {
        which: which,
        direction: 'forward'
      }
    });

  }

  play(options: PlayConfigurationModel) {
    Human.timeline.play({ startChapterId: options.chapterId, numChapters: 1, loop: options.loop });
  }

  unpause() {
    Human.timeline.unpause();
  }

  pause() {
    Human.timeline.pause();
  }

  // Human.timeline.scrub({
    //   time: 1
    // });

    // Human.timeline.activeRoot._nowBranch;
    // Human.timeline.activeRoot.mapGlobalTime(Human.timeline.time);

    // Sequence of events:
    // Human.timeline.activeRoot._nowBranch;
    // get branch timeline:               <branch>.getTimeframe()
    // convert local to globalTime:       Human.timeline.activeRoot.mapBranchTime(<branch>, 1);
    // scrub animation using globalTime:  Human.timeline.scrub(globalTime):  

    // Border conditions:
    // Human.timeline.borderConditions (both end of chapter and start of another)
    // Human.timeline.scrub({ time: 7, borderCondition: { which: 'second', direction: 'forward' }}) == start
    // Human.timeline.scrub({ time: 7, borderCondition: { which: 'first', direction: 'forward' }}) == end

    // Events
    // timeline.scrubbed (globalTime)
    // timeline.play

    // Playing (start conditions, end conditions, play conditions)
    // Human.timeline.play({ startChapterId: ..., numChapters: 1, loop: true })

}
